module.exports = __webpack_public_path__ + "static/media/dots-vertical.beddbf87.svg";